import { render, staticRenderFns } from "./DiscountPolicy.vue?vue&type=template&id=07325232&scoped=true&"
import script from "./DiscountPolicy.vue?vue&type=script&lang=js&"
export * from "./DiscountPolicy.vue?vue&type=script&lang=js&"
import style0 from "./DiscountPolicy.vue?vue&type=style&index=0&id=07325232&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07325232",
  null
  
)

export default component.exports